import p from "./ghl-ui.es719.js";
import h from "./ghl-ui.es720.js";
import r from "./ghl-ui.es721.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.__data__ = new p(); ++o < a; )
    this.add(t[o]);
}
e.prototype.add = e.prototype.push = h;
e.prototype.has = r;
export {
  e as default
};
